/**
 * @copyright 2025 Glimbr Pty Ltd
 * @version 2026-04-19-v1
 */
import type { ReactNode } from 'react';
import type { Tone } from '../../lib/types';

export function Chip({
    tone = 'muted',
    children,
    dot = false
}: {
    tone?: Tone;
    children: ReactNode;
    dot?: boolean;
}) {
    return (
        <span className="chip" data-tone={tone}>
            {dot && <span className="dot" />}
            {children}
        </span>
    );
}
